import React from "react";
import { Box, Typography } from "@mui/material";
import SealAddCard from "./SealAddCard";
import SealBarcodeCard from "./SealBarcodeCard";

// Dedicated Seals page: two separate tools — Add to Pool and Barcode PDF.
export default function SealsPage() {
  return (
    <Box sx={{ p: { xs: 2, md: 3 }, maxWidth: 900, mx: "auto" }}>
      <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2 }}>🏷 Seals</Typography>
      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" }, gap: 2 }}>
        <SealAddCard />
        <SealBarcodeCard />
      </Box>
    </Box>
  );
}
